var exports = {
  "k": "x9245d464--4940c9--container",
  "$": "x9245d464--4940c9--link-area",
};

module.exports = exports;
